import { atom } from "jotai"

/**
 * Whether the merchant's ACCOUNT is allowed to operate, as reported by
 * `GET /merchants/by-subdomain/:subdomain` in its `accessState` field.
 *
 * It is NOT the store's open/closed state. Hours, holidays and the merchant's
 * own close-store toggle all say "not right now"; this one says "not at all",
 * it is administrative, and only the panel can lift it. That is why it carries
 * no reopening estimate: there is no instant at which it lapses, and a wrong
 * "opens at" is worse than none.
 *
 * `null` means not answered yet. It is deliberately distinct from "ACTIVE" so a
 * bootstrap that has not resolved cannot be mistaken for a store cleared to
 * trade.
 */
export type MerchantAccessState = "ACTIVE" | "SUSPENDED"

const merchantAccessStateAtom = atom<MerchantAccessState | null>(null)

export default merchantAccessStateAtom
